module.exports = __webpack_public_path__ + "img/linux.a3ae3e8c.png";